import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGaurdService } from '../app/Global-Services/auth-gaurd.service';
import { APP_BASE_HREF } from '@angular/common';
import { ViewFTERecordsComponent } from './Module/Pages/view-fterecords/view-fterecords.component';
import { FTEDetailsComponent } from './Module/Pages/ftedetails/ftedetails.component';
import { HomeComponent } from './Module/Pages/home/home.component';
import { ErrorComponent } from './Module/Pages/error/error.component';
import { LogoutComponent } from './Module/Pages/logout/logout.component';
import { UnAuthorizeComponent } from './Module/Pages/un-authorize/un-authorize.component';
import { PageNotFoundComponent } from './Module/Pages/page-not-found/page-not-found.component';
import { LoginComponent } from './Module/Pages/login/login.component';
import { LayoutComponent } from './Module/UI/layout/layout.component';
import { FTERecordsComponent } from './Module/Pages/fterecords/fterecords.component';
import { FteformComponent } from './Module/Pages/fteform/fteform.component';
import { FteReviewedRecordsComponent } from './Module/Pages/fte-reviewed-records/fte-reviewed-records.component';
import { EmployeeExportComponent } from './Module/Pages/employee-export/employee-export.component';
import { GrantAccessMatrixComponent } from './Module/Access-Matrix/grant-access-matrix/grant-access-matrix.component';
import { BulkUploadAccessMatrixComponent } from './Module/Access-Matrix/bulk-upload-access-matrix/bulk-upload-access-matrix.component';
import { ViewAccessMatrixRecordComponent } from './Module/Access-Matrix/view-access-matrix-record/view-access-matrix-record.component';
import { CreateFinanceUserMappingComponent } from './Module/Access-Matrix/create-finance-user-mapping/create-finance-user-mapping.component';
import { ViewFinanceUserMappingComponent } from './Module/Access-Matrix/view-finance-user-mapping/view-finance-user-mapping.component';
import { InitiateRecordsFteComponent } from './Module/Pages/initiate-records-fte/initiate-records-fte.component';

const routes: Routes = [
    { path: '', component: LoginComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'INFTE', component: LayoutComponent,
    children: [
      {
        path: 'home', component: HomeComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin', 'Admin1', 'IsCounsellor', 'IsPartner', 'IsSLHR', 'IsManager', 'IsFinanceTeam', 'BUOUSpoc']
        }
      }
    ]
  },
  {
    path: 'View', component: LayoutComponent,
    children: [
      {
        path: 'ViewPendingForRenewal/:ParamID', component: ViewFTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin', 'IsCounsellor']
        }
      },
      {
        path: 'ViewPendingForApproval/:ParamID', component: ViewFTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin', 'IsPartner']
        }
      },
      {
        path: 'ViewPendingForEnd/:ParamID', component: ViewFTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin', 'IsSLHR']
        }
      },
      {
        path: 'ViewPendingToBeInitiated/:ParamID', component: ViewFTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin', 'IsSLHR']
        }
      },
      {
        path: 'ViewAll/:ParamID', component: ViewFTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin', 'IsCounsellor', 'IsPartner', 'IsSLHR', 'IsFinanceTeam']
        }
      },
      {
        path: 'FTEDetails/:ParamID', component: FTEDetailsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin', 'IsCounsellor', 'IsPartner', 'IsSLHR', 'IsFinanceTeam']
        }
      },
      {
        path: 'ViewPendingwithFinanceTeam/:ParamID', component: ViewFTERecordsComponent, canActivate: [AuthGaurdService], data: { // added by vedha bethi on 09-jun-2021 for CR_2103_0066
          expectedRole: ['Admin', 'IsFinanceTeam']
        }
      },
      {
        path: 'FTERecords/:ParamID', component: FTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin1', 'IsManager', 'IsPartner', 'BUOUSpoc']
        }
      },
      {
        path: 'PendingForEngagementCodeUpdate/:ParamID', component: FTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin1', 'IsManager', 'IsPartner', 'BUOUSpoc']
        }
      },
      {
        path: 'PendingForEngagementCodeReview/:ParamID', component: FTERecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin1', 'IsManager', 'IsPartner', 'BUOUSpoc']
        }
      },
      {
        path: 'FTEForm', component: FteformComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin1', 'IsManager', 'IsPartner', 'BUOUSpoc']
        }
      },
      {
        path: 'FTEForm/:ID', component: FteformComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin1', 'IsManager', 'IsPartner', 'BUOUSpoc']
        }
      },
      {
        path: 'FTEReview', component: FteReviewedRecordsComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin1', 'IsManager', 'IsPartner', 'BUOUSpoc']
        }
      },
      {
        path: 'RecordsExport', component: EmployeeExportComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin1', 'IsManager', 'IsPartner', 'BUOUSpoc']
        }
      },
      {
        path: 'GrantAccessMatrixComponent', component: GrantAccessMatrixComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      },
      {
        path: 'GrantAccessMatrixComponent/:ParamID', component: GrantAccessMatrixComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      },
      {
        path: 'BulkUploadAccessMatrixComponent', component: BulkUploadAccessMatrixComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      },
      {
        path: 'ViewAccessMatrixRecordComponent', component: ViewAccessMatrixRecordComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      },
       {
        path: 'CreateFinanceUserMappingComponent', component: CreateFinanceUserMappingComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      },
      {
        path: 'CreateFinanceUserMappingComponent/:ParamID', component: CreateFinanceUserMappingComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      },
       {
        path: 'ViewFinanceUserMappingComponent', component: ViewFinanceUserMappingComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      },
      {
        path: 'InitiateRecordsFteComponent', component: InitiateRecordsFteComponent, canActivate: [AuthGaurdService], data: {
          expectedRole: ['Admin']
        }
      }
    ]
  }, // Added by Samikchha Kumar on 25/04/2023
  // END by Samikchha Kumar on 25/04/2023

  { path: 'error/:id', component: ErrorComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'unAuthorize', component: UnAuthorizeComponent },
  { path: '**', component: PageNotFoundComponent }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }, AuthGaurdService]
})
export class AppRoutingModule { }
